<template>
  <pp-modal v-model="showModal" :mask-closable="false" width="368" :closable="false">
    <div class="modalhead">
        <div class="">流水详情1</div>
        <div class="secondTitle">流水号:LS201709121145041004</div>
    </div>
    <div class="content">
        <div class="line">
            <div class="fl">业务类型</div>
            <div class="fr">保证金入账</div>
        </div>
        <div class="line">
            <div class="fl">来源网站订单号</div>
            <div class="fr">24543234235</div>
        </div>
        <div class="line">
            <div class="fl">交易流水号</div>
            <div class="fr">24543234235_bzj</div>
        </div>
        <div class="line">
            <div class="fl">入账金额</div>
            <div class="fr">2,013.00 USD</div>
        </div>
        <div class="line">
            <div class="fl">产生费用</div>
            <div class="fr">0 USD</div>
        </div>
        <div class="line">
            <div class="fl">入账时间</div>
            <div class="fr">2017-10-18 20:33:22</div>
        </div>
        <div class="bankline">
            <img src="/static/imgs/login/logo.png" >
            <div class="info">
                <div>招商银行</div>
                <div>1234 **** **** 1234</div>
            </div>
        </div>
    </div>
    <div slot="footer" class="textright">
        <pp-button class="modal-btn" type="primary"  size="spec" @click="sure" >确认</pp-button>
    </div>
  </pp-modal>

</template>
<script>


 import {
        Component,
        Vue,
        Prop,
        Watch
    } from 'vue-property-decorator'
    
    export default {
        name: 'flowDetailModal',
        props: {
            tourl: "",
            modalcontent: "",
            modalheader: "",
            modalbtn: "",
    
        },
        mounted() {},
        data() {
            return {
                showModal: true
            }
        },
        methods: {
            sure(){

            },
            show() {
                this.showModal = true
            },
            skipeTo() {
                this.$replace(this.tourl)
            }
        }
    }



</script>
<style lang="scss" scoped>
.modalhead{
        display: block;
    width: 100%;
    height: 60px;
    line-height: 30px;
    font-size: 20px;
    color: #1c2438;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
}
.textright .modal-btn{
    padding: 6px 20px;
      height: 32px;
      text-align: center;
      font-size: 14px;
}
.secondTitle{
    color:#000;
    font-size:14px;
    height: 18px;
    line-height: 18px;
    text-align:left;
    filter: alpha(opacity=56);
    -moz-opacity: 0.56;
    -khtml-opacity: 0.56;
    opacity: 0.56;
    margin-bottom: 4px;
}
.modalContent{
    text-align:left;
    font-size:14px;
}
.content{
    width: 100%;
    .line{
        height: 20px;
        font-size: 14px;
        line-height: 20px;
        margin-top: 16px;
    }
    .bankline{
        margin-top: 16px;
        height: 70px;
        img{
            float: left;
            display: block;
            width: 64px;
            height: 64px;
        }
        .info{
            height: 64px;
            float: left;
            margin: 0 0 0 41px; 
            div{
                height: 32px;
                line-height: 32px;
            }
        }
        
    }
}


</style>
